import { render, staticRenderFns } from "./Profiles.vue?vue&type=template&id=041133bc"
import script from "./Profiles.vue?vue&type=script&lang=js"
export * from "./Profiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports